import * as React from 'react';
import { Button, Text, Image, Flex, Loader, Dialog, List, Form, FormInput } from '@fluentui/react-northstar';
import axios from 'axios';
import { References } from '../helpers/References';
import { Helpers } from '../helpers/Helpers';
import { DataCenterData, DataCentersButton, serversOptions } from './Login';
import LexzurIcon from "../Images/lexzur-icon-white.png";
import ServerIcon from "../Images/server.svg";
import EnvelopeIcon from "../Images/envelope.svg";
import NortonIcon from "../Images/norton.svg";
import GdprIcon from "../Images/gdpr.jpg";

var dialogMessage;
var dialogHeader = 'Information';
export default class LoginSSOComponent extends React.Component<ILoginProps, ILoginState> {
    isMigrated: string;
    goToUrl: string;
    email: string;
    mode: string;
    type: string;
    isAzure: boolean;
    constructor(props) {
        super(props);
        this.state = { isLoading: false, openDialog: false, dataCenter: null };
        this.handleSubmitForm = this.handleSubmitForm.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.handleInstanceClick = this.handleInstanceClick.bind(this);
        this.isMigrated = '1';
        this.email = Helpers.getUrlPar('email');
        this.goToUrl = Helpers.getUrlPar('url')?.length > 0 ? Helpers.getUrlPar('url') : null;
        this.mode = Helpers.getUrlPar('mode');
        this.type = Helpers.getUrlPar('type');
        this.isAzure = Helpers.getUrlPar('isAzure') === 'true';
    }
    componentDidMount(): void {
        let currentDataCenter = this.type ? serversOptions.find(option => option.value === this.type) : null;
        this.setState({
            dataCenter: currentDataCenter
        })
    }
    handleInstanceClick(instanceId = null) {
        if (this.goToUrl?.length > 0) {
            var instanceUrl = '';
            if (instanceId?.length > 0)
                instanceUrl = this.goToUrl + "/" + instanceId + "/";
            else
                instanceUrl = this.goToUrl + (this.goToUrl.slice(-1) === '/' ? '' : '/');
            var redirectURL = window.location.origin + '/ssoredirect';
            var encodedURLBtoA = btoa(redirectURL);
            sessionStorage.setItem('instance_url', instanceUrl);
            var url = instanceUrl + 'users/login_sso_external';
            if (!this.isAzure) {
                url += '/other';
            }
            url += '?redirect_url=' + encodedURLBtoA; 
            window.location.replace(url);
        }
    }
    async handleSubmitForm(e, props) {
        let serverOption = this.state.dataCenter?.value ?? 'site';
        let signInCloud = References.newSignInCloudApi(serverOption);
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isLoading: true });
        if (this.goToUrl) {
            //self-hosted client
            this.handleInstanceClick();
        }
        else {
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
            };
            var requestData = new FormData();
            requestData.append("email", this.email);
            requestData.append("userLogin", this.email);
            axios.post(signInCloud, requestData, {
                headers: headers
            }).then(response => {
                var resp = response.data;
                var error = resp.error;
                if (error != null) {
                    console.log(error);
                    dialogMessage = error;
                    this.setState({ isLoading: false, openDialog: true });
                }
                else {
                    this.goToUrl = resp.goToURL;
                    var instances = resp.instances;
                    var count = Object.keys(instances);
                    var self = this;
                    if (count.length == 1) {
                        this.handleInstanceClick(count[0]);
                    }
                    else {
                        var items = [];
                        Object.keys(instances).forEach(function (key) {
                            items.push({
                                header: instances[key],
                                onClick: (e, props) => { self.handleInstanceClick(key) }
                            });
                        });
                        dialogHeader = 'Select Instance';
                        //More than one instance
                        dialogMessage = <List items={items} selectable />;
                        this.setState({ isLoading: false, openDialog: true });
                    }
                }
            }).catch(error => {
                console.log(error);
                dialogMessage = error;
                this.setState({ isLoading: false, openDialog: true });
            });
        }
    }
    handleInputChanged(e, props) {        
        this[props.name] = props.value;
    }
    render() {
        let appLogo = LexzurIcon;
        return (
            <div style={{ height: '100%', width: '100%', backgroundColor: this.props.theme == 'default' ? '#fff' : (this.props.theme == 'dark' ? '#2d2c2c' : '#000') }}>
                <div style={{ position: 'absolute', top: '0px', height: '200px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundImage: "url('/images/peopleGroup.jpg')" }}>
                    <Image src={appLogo} styles={{ width: '200px', marginTop: '-75px' }} />
                </div>
                <Flex column hAlign='center' vAlign='center' styles={{ width: '85%', margin: 'auto', paddingTop: '20px' }} gap='gap.medium'>
                    <div style={{
                        width: '100%',
                        borderTopLeftRadius: '50px',
                        borderTopRightRadius: '50px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'white', position: 'absolute', top: '120px', padding: '0 15px'
                    }}>
                        <div style={{ height: '20px' }}></div>
                        <Button text content='Back' onClick={(e, props) => {
                            e.preventDefault();
                            e.stopPropagation();
                            window.location.href = '/login';
                        }} />
                        <div style={{ height: '20px' }}></div>
                        <Form onSubmit={this.handleSubmitForm}>
                            {this.mode === 'server' &&
                                <FormInput clearable
                                    defaultValue={this.goToUrl}
                                    iconPosition='start'
                                    input={{ styles: { border: '0.5px solid lightGrey' } }}
                                    icon={{ content: <Image src={ServerIcon} />, styles: { marginLeft: '10px' } }}
                                    inverted fluid
                                    placeholder='URL'
                                    name='goToUrl' required onChange={this.handleInputChanged} />
                            }
                            {this.mode === 'cloud' &&
                                <FormInput clearable
                                    defaultValue={this.email}
                                    iconPosition='start'
                                    input={{ styles: { border: '0.5px solid lightGrey' } }}
                                    icon={{ content: <Image src={EnvelopeIcon} />, styles: { marginLeft: '10px' } }}
                                    inverted fluid placeholder='Email' name='email' required onChange={this.handleInputChanged} />
                            }
                            {this.mode === 'cloud' && <DataCentersButton onItemClicked={(event, data) => {
                                let index = data?.index;
                                this.setState({ dataCenter: serversOptions[index] })
                            }} dataCenter={this.state.dataCenter} />}
                            {this.state.isLoading ? <Loader /> : <Button
                                type='submit'
                                content='Sign in'
                                styles={{
                                    color: 'white',
                                    backgroundColor: '#155495',
                                    margin: 'auto',
                                    borderRadius: '35px',
                                    height: "39px",
                                    width: "90%"
                                }}
                            />}
                        </Form>
                        <div style={{ height: '20px' }}></div>                        
                        <Button text content={`New to ${Helpers.getAppName()}? Sign up`} onClick={(e, props) => {
                            e.preventDefault();
                            e.stopPropagation();
                            window.open(References.newSignupURL(this.state.dataCenter?.value));
                        }} /> 
                        <Text content={<div style={{ textAlign: 'center' }}>
                            Learn more about our <a target='_blank' href='termsconditions'>Security</a> & <a target='_blank' href='/privacypolicy'>Privacy Policy</a>
                        </div>
                        }
                            styles={{ marginTop: '25px' }} />
                        <Flex gap='gap.medium'>
                            <Image src={NortonIcon} />
                            <Image styles={{ width: '40px' }} src={GdprIcon} />
                        </Flex>
                    </div>
                    <Dialog
                        styles={{ width: '80%' }}
                        open={this.state.openDialog}
                        header={dialogHeader}
                        content={dialogMessage}
                        cancelButton="Cancel"
                        onCancel={() => { this.setState({ openDialog: false }) }}
                    />
                </Flex>
            </div>
        );
    }
}
interface ILoginProps {
    theme: string;
}

interface ILoginState {
    isLoading: boolean;
    openDialog: boolean;
    dataCenter: DataCenterData;
}